import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import { Modal } from "react-bootstrap";
import NewAddress from "../../Modal/NewAddress";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { socket } from "../../utils/Socket";
import { fetchServerDraftRowByQuotationSearch, serverDraftRowToQuotesCreatePayload } from "../../utils/quoteDraftServer";
import { toast } from "react-toastify";

function AddressSelect() {
  const addressList = useMakeRequest();
  const shippingList = useMakeRequest();
  const quoteAdd = useMakeRequest();
  const [show, setShow] = useState(false);
  const [data, setData] = useState<any>({});
  const [error, setError] = useState<any>({});
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [quoteDetails, setQuoteDetails] = useState<{ quotes: any[] } | null>(null);

  useEffect(() => {
    const draftQ = searchParams.get("draft");
    if (!draftQ) {
      setQuoteDetails(null);
      return;
    }
    let cancelled = false;
    void (async () => {
      const row = await fetchServerDraftRowByQuotationSearch(draftQ);
      if (cancelled) return;
      if (!row) {
        setQuoteDetails(null);
        toast.error(LanguageConstants?.DATANOTFOUND ?? "");
        return;
      }
      const quotes = serverDraftRowToQuotesCreatePayload(row);
      setQuoteDetails({ quotes });
    })();
    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  useEffect(() => {
    addressList.makeRequest({ url: ApiConstants?.AddressList, toastStatus: false });
    shippingList.makeRequest({ url: ApiConstants?.ShippingList, toastStatus: false });
  }, [show]);

  const handleClose = () => {
    setShow(false);
  };

  const handleInputValues = (e: any) => {
    const { name, value } = e.target;
    setData((data: any) => ({ ...data, [name]: value }));
  };

  const handleNextPage = () => {
    const errobj: any = {};
    if (!data?.shipping_id) {
      errobj.shipping = LanguageConstants?.PLEASE_SELECT_SHIPPING_TYPE;
    }
    if (!data?.address_id) {
      errobj.address = LanguageConstants?.PLEASE_SELECR_DELIVER_ADDRESS;
    }
    if (Object.keys(errobj).length > 0) {
      setError(errobj);
    } else {
      if (!quoteDetails?.quotes?.length) {
        toast.error(LanguageConstants?.DATANOTFOUND ?? "");
        return;
      }
      const payload = {
        shipping_id: data?.shipping_id,
        address_id: data?.address_id,
        ...quoteDetails,
      };
      quoteAdd.makeRequest({ payload, url: ApiConstants?.QuotesAdd, toastStatus: true });
    }
  };

  useEffect(() => {
    if (quoteAdd?.status) {
      const payload = {
        sender_type: "1",
        receiver_id: "1",
      };
      socket.emit("admin_count", payload, async () => {});
      navigate("/my-quotation");
    }
  }, [quoteAdd.status, navigate]);

  return (
    <>
      {quoteAdd?.loading || addressList.loading ? <FrontLoader /> : null}
      <main>
        <section className="main-banner small-banner" style={{ background: `url(${profileBanner}) center/cover` }}>
          <div className="container">
            <h1 className="small-banner-heading">{LanguageConstants?.REQUESTQUOTES}</h1>
          </div>
        </section>

        <div className="container footer-space">
          <h2 className="title-1">
            {LanguageConstants?.REQUESTVIA} {LanguageConstants?.QUOTATIONFORM}
          </h2>
          <div className="card-box">
            <div className="row">
              <div className="col-md-5 col-lg-4">
                <div className="com-input-wrap">
                  <label className="form-label">
                    {LanguageConstants?.DELIVERYADDRESS} <span className="input-star">*</span>
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    name="address_id"
                    onChange={handleInputValues}
                  >
                    <option selected value="">
                      {LanguageConstants?.DELIVERYADDRESS}
                    </option>
                    {addressList?.data?.data?.rows?.map((res: any, i: any) => (
                      <option value={res?.id} key={i}>
                        {res?.street_line}
                      </option>
                    ))}
                  </select>
                </div>
                <p style={{ color: "red" }}>{error?.address}</p>
              </div>
              <div className="col-auto mx-auto m-md-0" />
              <div className="col-md-5 col-lg-4">
                <div className="com-input-wrap">
                  <label className="form-label">
                    {LanguageConstants?.SHIPPINGMETHOD} <span className="input-star">*</span>
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    name="shipping_id"
                    onChange={handleInputValues}
                  >
                    <option selected value="">
                      {LanguageConstants?.SHIPPINGMETHOD}
                    </option>
                    {shippingList?.data?.data?.map((resp: any, i: any) => (
                      <option value={resp?.id} key={i}>
                        {resp?.shipping_details?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <p style={{ color: "red" }}>{error?.shipping}</p>
              </div>
              <div className="col-md-12 col-lg-3 ms-0 ms-lg-auto ps-3 ps-lg-0 mt-3 mt-lg-0 add-address-btn mb-0 mb-lg-3">
                <div className="add-new-address com-input-wrap">
                  <label className="form-label d-none d-lg-block" />
                  <div className="add-txt">
                    <span className="cursor-pointer" onClick={() => setShow(true)}>
                      +{LanguageConstants?.NEWADDRES}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <button type="button" className="round-btn w-100 quote-btn-space" onClick={() => handleNextPage()}>
                  {LanguageConstants?.REQUESTQUOTE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Modal show={show}>
        <NewAddress handleClose={handleClose} />
      </Modal>
    </>
  );
}

export default AddressSelect;
